<app-rb-grid
  [gridConfig]="gridConfig"
  [getSetup]="getGridSetup"
  [getData]="getGridData"
>
  <button
    mat-raised-button
    color="primary"
    class="header-button"
    (click)="downloadPolicyList()"
    [disabled]="fileLoading"
    matTooltip="Limit 100,000"
    matTooltipPosition="above"
  >
    <span class="button-label-with-icon">
      @if (fileLoading) {
        <mat-spinner diameter="20"></mat-spinner>
      } @else {
        <mat-icon>cloud_download</mat-icon>
      }
      Download Policy List
    </span>
  </button>
</app-rb-grid>
